import { useEffect, useState } from 'react';

const useResendTimer = (initialTime = 45) => {
    const [disableResend, setDisableResend] = useState(true);
    const [timer, setTimer] = useState(initialTime);

    const startTimer = () => {
        setDisableResend(true);
        setTimer(initialTime);
    };

    useEffect(() => {
        let interval;

        if (disableResend) {
            interval = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setDisableResend(false);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [disableResend, initialTime]);

    return { disableResend, timer, startTimer };
};

export default useResendTimer;
